









import { Component } from 'vue-property-decorator'
import { LayoutComponentVue } from '@/base'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'

@Component
export default class SampleLayout extends LayoutComponentVue {
  loading = false

  mounted() {
    this.$webSocket.connect()
  }

  created() {
    this.$eventBus.on(PAGE_LOADING_START, this.onPageLoadingStart)
    this.$eventBus.on(PAGE_LOADING_END, this.onPageLoadingEnd)
    this.$webSocket.connect()
  }

  destroyed() {
    this.$eventBus.off(PAGE_LOADING_START)
    this.$eventBus.off(PAGE_LOADING_END)
  }

  onPageLoadingStart() {
    this.loading = true
  }

  onPageLoadingEnd() {
    this.loading = false
  }
}
